import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import ActiveLink from "@/components/ActiveLink";
import DropdownMenu from "@/components/DropdownMenu";
import { SearchForm, SearchFormSp } from "@/components/Form/index";
import LogoutModal from "@/components/LogoutModal";
import { useAdultModeQuery, useAuthUserQuery, useModal } from "@/hooks";
import { profileIconImages } from "@/lib/constants";
import routes from "@/lib/routes";
import dropDownStyles from "@/styles/DropdownMenu.module.scss";
import styles from "@/styles/Header.module.scss";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback } from "react";

var IconArrow = function IconArrow(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("g", {
      transform: "translate(0.813 0.813)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M.6.6l6,6.5,6-6.5",
        fill: "none",
        stroke: "#e6e6e6",
        strokeLinecap: "round",
        strokeWidth: "2"
      })
    })
  }));
};

IconArrow.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.826",
  height: "9.387",
  viewBox: "0 0 14.826 9.387"
};
import Notice from "./Notice";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function AuthorizedNavigation(_ref) {
  var _loggedIn$currentProf, _loggedIn$currentProf2;

  var loggedIn = _ref.loggedIn;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      _useAdultModeQuery$da = _useAdultModeQuery.data;

  _useAdultModeQuery$da = _useAdultModeQuery$da === void 0 ? {} : _useAdultModeQuery$da;
  var adultMode = _useAdultModeQuery$da.adultMode;

  var _useModal = useModal(),
      showModal = _useModal.showModal;

  var showLogoutModal = useCallback(function () {
    showModal( /*#__PURE__*/_jsx(LogoutModal, {}), {
      closeButton: false,
      style: "logout"
    });
  }, []);
  if (!loggedIn) return null;
  if (!(loggedIn !== null && loggedIn !== void 0 && loggedIn.currentProfile)) return null;
  var ownerProfile = loggedIn === null || loggedIn === void 0 ? void 0 : (_loggedIn$currentProf = loggedIn.currentProfile) === null || _loggedIn$currentProf === void 0 ? void 0 : _loggedIn$currentProf.ownerProfile;
  var iconId = (loggedIn === null || loggedIn === void 0 ? void 0 : (_loggedIn$currentProf2 = loggedIn.currentProfile) === null || _loggedIn$currentProf2 === void 0 ? void 0 : _loggedIn$currentProf2.icon) || 1;
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(styles.navElement, " ").concat(styles.user),
    children: /*#__PURE__*/_jsx("ul", {
      className: styles.user,
      children: /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsxs(DropdownMenu, {
          right: true,
          button: /*#__PURE__*/_jsxs("a", {
            className: styles.userMenuOpenBtn,
            role: "button",
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.profileImage,
              children: /*#__PURE__*/_jsx(Image, {
                src: profileIconImages[iconId],
                width: 28,
                height: 28
              })
            }), /*#__PURE__*/_jsxs("span", {
              className: styles.profileName,
              children: [loggedIn.currentProfile.displayName, /*#__PURE__*/_jsx("span", {
                className: styles.iconDropdown,
                children: /*#__PURE__*/_jsx(IconArrow, {})
              })]
            })]
          }),
          scopedClass: dropDownStyles.forHeaderMenu,
          children: [/*#__PURE__*/_jsx("div", {
            className: "".concat(dropDownStyles.innerSection, " ").concat(styles.dropDownProfileName),
            children: /*#__PURE__*/_jsx("div", {
              children: loggedIn.currentProfile.displayName
            })
          }), /*#__PURE__*/_jsx("div", {
            className: dropDownStyles.innerSection,
            children: /*#__PURE__*/_jsxs("ul", {
              className: dropDownStyles.lists,
              children: [ownerProfile && /*#__PURE__*/_jsx("li", {
                className: dropDownStyles.list,
                children: /*#__PURE__*/_jsx(Link, {
                  href: routes.account,
                  children: /*#__PURE__*/_jsx("a", {
                    className: dropDownStyles.link,
                    children: "\u30A2\u30AB\u30A6\u30F3\u30C8"
                  })
                })
              }), !adultMode && /*#__PURE__*/_jsx("li", {
                className: dropDownStyles.list,
                children: /*#__PURE__*/_jsx(Link, {
                  href: routes.profileSwitch(),
                  children: /*#__PURE__*/_jsx("a", {
                    className: dropDownStyles.link,
                    children: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u5207\u308A\u66FF\u3048"
                  })
                })
              })]
            })
          }), /*#__PURE__*/_jsx("div", {
            className: dropDownStyles.innerSection,
            children: /*#__PURE__*/_jsx("ul", {
              className: dropDownStyles.lists,
              children: /*#__PURE__*/_jsx("li", {
                className: dropDownStyles.list,
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/static/feature/constant/guide",
                  children: /*#__PURE__*/_jsx("a", {
                    className: dropDownStyles.link,
                    children: "\u3054\u5229\u7528\u30AC\u30A4\u30C9"
                  })
                })
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: dropDownStyles.innerSection,
            children: /*#__PURE__*/_jsx("ul", {
              className: dropDownStyles.lists,
              children: /*#__PURE__*/_jsx("li", {
                className: dropDownStyles.list,
                children: /*#__PURE__*/_jsx("a", {
                  className: dropDownStyles.link,
                  onClick: showLogoutModal,
                  children: "\u30ED\u30B0\u30A2\u30A6\u30C8"
                })
              })
            })
          })]
        })
      })
    })
  });
}

function NotAuthorizedNavigation(_ref2) {
  var loggedIn = _ref2.loggedIn;
  if (loggedIn) return null;
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(styles.navElement, " ").concat(styles.anonymous),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.btnArea,
      children: [/*#__PURE__*/_jsx(ActiveLink, {
        href: routes.login,
        children: /*#__PURE__*/_jsx("a", {
          className: styles.secondaryNavigationContLink,
          children: /*#__PURE__*/_jsx("span", {
            children: "\u30ED\u30B0\u30A4\u30F3"
          })
        })
      }), /*#__PURE__*/_jsx(ActiveLink, {
        href: routes.signUp,
        children: /*#__PURE__*/_jsx("a", {
          className: styles.secondaryNavigationContLink,
          children: /*#__PURE__*/_jsx("span", {
            children: "\u4F1A\u54E1\u767B\u9332"
          })
        })
      })]
    })
  });
}

export default function SecondaryNavigation() {
  var router = useRouter();

  var _useAuthUserQuery = useAuthUserQuery({
    fetchPolicy: "cache-first"
  }),
      loading = _useAuthUserQuery.loading,
      data = _useAuthUserQuery.data;

  var loggedIn = !loading && (data === null || data === void 0 ? void 0 : data.user);
  var handleSubmit = useCallback(function (data) {
    router.push(routes.search(data.search));
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.secondaryNavigation,
    children: [/*#__PURE__*/_jsx(SearchForm, {
      onSubmit: handleSubmit
    }), /*#__PURE__*/_jsx(SearchFormSp, {
      onSubmit: handleSubmit
    }), /*#__PURE__*/_jsx(Notice, {}), /*#__PURE__*/_jsx(NotAuthorizedNavigation, {
      loggedIn: loggedIn
    }), /*#__PURE__*/_jsx(AuthorizedNavigation, {
      loggedIn: loggedIn
    })]
  });
}